import { useBookingListQuery } from 'lib/graphql/generated';
import { BOOKING_LIST_LOAD_LIMIT } from 'config/constants';

export const usePreloadBookings = () => {
  useBookingListQuery({
    variables: { limit: BOOKING_LIST_LOAD_LIMIT, offset: 0, filter: 'UPCOMING' },
    fetchPolicy: 'cache-and-network',
  });
  useBookingListQuery({
    variables: { limit: BOOKING_LIST_LOAD_LIMIT, offset: 0, filter: 'COMPLETED' },
    fetchPolicy: 'cache-and-network',
  });
  useBookingListQuery({
    variables: { limit: BOOKING_LIST_LOAD_LIMIT, offset: 0, filter: 'CANCELLED' },
    fetchPolicy: 'cache-and-network',
  });
};
